<template>
    <div class="grid-container content-padding">
        <div class="grid-x">
            <div class="food-side-content">
                <page-header :title="title"></page-header>
            </div>
            <div class="cell large-7 xlarge-8 large-offset-5 xlarge-offset-4">
                <div class="grid-x grid-padding-x">
                    <div class="cell policy" v-html="content"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Route } from 'vue-router';
import Settings, { SettingNamespace } from '@/utils/settings';
import PageHeader from '@/components/front/ui/PageHeader.vue';

Component.registerHooks([
    'beforeRouteEnter'
]);
@Component({
    components: {PageHeader}
})
export default class Policy extends Vue
{
    @Prop(String) readonly type!: String;
    content: string = '';

    created() {
        this.fetchPolicy();
    }

    beforeRouteEnter(to: Route, from: Route, next: Function) {
        next((vm: Policy) => vm.fetchPolicy());
    }

    public async fetchPolicy() {
        const settings = await Settings.getInstance();
        this.content = settings.get(SettingNamespace.CONTENT, this.policyField)?.value.replace('h1', 'h2');
    }

    get title() {
        if (this.type === 'privacy-policy') {
            return 'Privacy Policy';
        }
        if (this.type === 'cookie-policy') {
            return 'Cookie Policy';
        }
        return 'Terms of use';
    }

    get policyField() {
        if (this.type === 'privacy-policy') {
            return 'privacy_policy';
        }
        if (this.type === 'cookie-policy') {
            return 'cookie_policy';
        }
        return 'terms';
    }
}
</script>
<style lang="scss" scoped>
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.policy {
    padding-top: 10px;

    @include breakpoint (medium down) {
        padding-top: 120px;
    }
}
</style>